import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { apiVariable } from "../../../api/apiVariable";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import { Button } from "@mui/material";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import {
  settlementPayeeFieldConfiguration,
  settlementPayeeInitialValues,
} from "../../../formConfigs/Fleet/settlementPayeeFieldConfig";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";

const SettlementPayeePopup = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setStatus("idle");

  const { token } = useAuth();

  const mutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/createSettlementPayee`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["settlementPayees"] });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(
        error.response.data || "Failed to submit settlement payee"
      );
    },
  });

  const submitHandler = (data: any) => {
    mutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Add Settlement Payee
      </Button>
      <GenericFormPopup
        formFields={settlementPayeeFieldConfiguration}
        initialValues={settlementPayeeInitialValues}
        title="Add Settlement Payee"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        loading={mutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage="Settlement payee added successfully"
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default SettlementPayeePopup;
